var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        width: "dialogWidth",
        height: "100%",
        "content-class": "pnmpp-containerdialog"
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "v-icon",
        {
          staticClass: "pnm-close",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.closeDialog()
            }
          }
        },
        [_vm._v("close")]
      ),
      _vm._v(" "),
      _c("v-card", [
        _c("iframe", { attrs: { src: _vm.url, id: "pnm-iframe" } })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5235efa3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5235efa3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PNMDialog.vue
// module id = null
// module chunks = 